/* MUMSAN: premium mobil arama paneli (canlı sonuç + kategori / renk / adet / özellik filtreleri) */
(() => {
  const dialog = document.getElementById('mx-search-sheet');
  if (!dialog || dialog.dataset.ready) return;
  dialog.dataset.ready = '1';

  const $ = (sel, root = dialog) => root.querySelector(sel);
  const $$ = (sel, root = dialog) => Array.from(root.querySelectorAll(sel));
  let S = {};
  try { S = JSON.parse(dialog.dataset.strings || '{}'); } catch (e) { S = {}; }

  const input = $('[data-mx-ss-input]');
  const form = $('.mx-ss__form');
  const clearBtn = $('[data-mx-ss-clear]');
  const body = $('[data-mx-ss-body]');
  const filtersPanel = $('[data-mx-ss-filters]');
  const filtersToggle = $('[data-mx-ss-toggle-filters]');
  const filterCount = $('[data-mx-ss-filter-count]');
  const applyBtn = $('[data-mx-ss-apply]');
  const activeWrap = $('[data-mx-ss-active]');
  const intro = $('[data-mx-ss-intro]');
  const results = $('[data-mx-ss-results]');
  const grid = $('[data-mx-ss-grid]');
  const countEl = $('[data-mx-ss-count]');
  const empty = $('[data-mx-ss-empty]');
  const emptyText = $('[data-mx-ss-empty-text]');
  const moreBtn = $('[data-mx-ss-more]');
  const loading = $('[data-mx-ss-loading]');
  const sortSel = $('[data-mx-ss-sort]');
  const allLink = $('[data-mx-ss-all]');
  const recentWrap = $('[data-mx-ss-recent-wrap]');
  const recentEl = $('[data-mx-ss-recent]');
  const catsEl = $('[data-mx-ss-cats]');
  const featuredEl = $('[data-mx-ss-featured]');

  const PAGE = 24;
  const RECENT_KEY = 'mx-ss-recent';
  const CACHE_KEY = 'mx-ss-index-v2';
  let items = null;
  let loadPromise = null;
  let failed = false;
  let lastFocus = null;
  let shown = PAGE;
  const state = { q: '', type: new Set(), color: new Set(), qty: new Set(), feat: new Set(), sort: 'relevance' };

  /* ---------- yardımcılar ---------- */
  const norm = (s) => String(s || '')
    .toLocaleLowerCase('tr')
    .replace(/ç/g, 'c').replace(/ğ/g, 'g').replace(/ı/g, 'i').replace(/i̇/g, 'i')
    .replace(/ö/g, 'o').replace(/ş/g, 's').replace(/ü/g, 'u').replace(/â/g, 'a').replace(/î/g, 'i').replace(/û/g, 'u')
    .replace(/[’'`]/g, "'").trim();
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const tpl = (str, map) => String(str || '').replace(/\{\{\s*(\w+)\s*\}\}/g, (_, k) => (map[k] != null ? map[k] : ''));
  const countLabel = (n) => tpl(n === 1 ? S.count_one : S.count_other, { count: n });

  /* Renk aileleri: ürün renk değerleri bu ailelere eşlenir (Mat Kırmızı → Kırmızı) */
  const FAMILIES = [
    ['cok renkli', 'Çok Renkli', 'conic-gradient(#9B1C2C, #E6C14A, #2F6B45, #2F5D9B, #5B3A73, #9B1C2C)'],
    ['pembe altin', 'Pembe Altın', 'linear-gradient(135deg,#E8C1B3,#C99382)'],
    ['acik mavi', 'Açık Mavi', '#A9CBE6'],
    ['acik yesil', 'Açık Yeşil', '#A8CFA0'],
    ['turkuaz', 'Turkuaz', '#2BA9A6'],
    ['kirmizi', 'Kırmızı', '#9B1C2C'],
    ['bordo', 'Bordo', '#5A1F2E'],
    ['pembe', 'Pembe', '#E3A6B6'],
    ['mor', 'Mor', '#5B3A73'],
    ['lacivert', 'Lacivert', '#1B2638'],
    ['mavi', 'Mavi', '#2F5D9B'],
    ['yesil', 'Yeşil', '#2F6B45'],
    ['siyah', 'Siyah', '#1A1A1A'],
    ['sedef', 'Beyaz', '#F6F3EE'],
    ['beyaz', 'Beyaz', '#F6F3EE'],
    ['krem', 'Krem', '#EFE3CC'],
    ['bej', 'Bej', '#D9C6A5'],
    ['sari', 'Sarı', '#E6C14A'],
    ['gold', 'Gold', 'linear-gradient(135deg,#E3C57A,#B08A3E)'],
    ['altin', 'Gold', 'linear-gradient(135deg,#E3C57A,#B08A3E)'],
    ['silver', 'Silver', 'linear-gradient(135deg,#ECECEC,#A9A9A9)'],
    ['gumus', 'Silver', 'linear-gradient(135deg,#ECECEC,#A9A9A9)'],
    ['bronz', 'Bronz', 'linear-gradient(135deg,#C08A55,#7E5530)'],
    ['gri', 'Gri', '#8C8A88'],
    ['turuncu', 'Turuncu', '#D2722B'],
    ['kahverengi', 'Kahverengi', '#6B4630'],
    ['kahve', 'Kahverengi', '#6B4630'],
  ];
  const SWATCH = {};
  FAMILIES.forEach(([, label, sw]) => { SWATCH[label] = sw; });
  const familiesOf = (value) => {
    const out = new Set();
    String(value || '').split(/&|,|\/|\+| ve /i).forEach((part) => {
      const n = norm(part);
      if (!n) return;
      const hit = FAMILIES.find(([key]) => n.includes(key));
      if (hit) out.add(hit[1]);
    });
    return out;
  };

  const QTY_RE = /(\d{1,4})\s*['’‘`]?\s*(li|lı|lu|lü|lık|lik|luk|lük)(?![a-zçğıöşü])/i;

  function enrich(raw) {
    const tags = (raw.g || []).map(norm);
    const colors = new Set();
    let matte = false;
    (raw.r || []).forEach((v) => {
      familiesOf(v).forEach((f) => colors.add(f));
      if (/^mat\b/.test(norm(v))) matte = true;
    });
    const m = QTY_RE.exec(raw.t || '');
    const qty = m ? parseInt(m[1], 10) : null;
    const feats = new Set();
    if (tags.includes('kokulu') || /kokulu/.test(norm(raw.t))) feats.add('scented');
    if (tags.some((t) => t.startsWith('hediye')) || /hediye/.test(norm(raw.t))) feats.add('gift');
    if (raw.a) feats.add('stock');
    if (matte || tags.includes('mat')) feats.add('matte');
    if (tags.includes('premium') || tags.includes('prestij')) feats.add('premium');
    if (raw.c && raw.c > raw.p) feats.add('sale');
    const cols = [...new Set((raw.k || []).filter(Boolean))];
    return {
      ...raw,
      cols,
      colors,
      qty,
      feats,
      nt: norm(raw.t),
      hay: norm([raw.t, raw.y, (raw.k || []).join(' '), (raw.g || []).join(' '), (raw.r || []).join(' ')].join(' ')),
    };
  }

  /* ---------- veri ---------- */
  async function fetchPage(page) {
    /* Mevcut sayfa adresi + sorgu parametreleri korunur; böylece önizleme / Canvas sürümü de doğru veriyi alır */
    const url = new URL(location.href);
    url.hash = '';
    ['q', 'type', 'options[prefix]', 'filter', 'sort_by'].forEach((k) => url.searchParams.delete(k));
    url.searchParams.set('section_id', 'mumsan-search-index');
    url.searchParams.set('page', page);
    const res = await fetch(url.toString(), { credentials: 'same-origin' });
    if (!res.ok) throw new Error('index ' + res.status);
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const node = doc.querySelector('[data-mx-ss-index]');
    if (!node) throw new Error('index missing');
    return JSON.parse(node.textContent);
  }

  function loadIndex() {
    if (items) return Promise.resolve(items);
    if (loadPromise) return loadPromise;
    try {
      const cached = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (cached && Date.now() - cached.at < 30 * 60 * 1000 && Array.isArray(cached.items)) {
        items = cached.items.map(enrich);
        return Promise.resolve(items);
      }
    } catch (e) { /* önbellek yok */ }
    loading.hidden = false;
    loadPromise = fetchPage(1)
      .then(async (first) => {
        let all = first.items || [];
        const pages = Math.min(first.pages || 1, 20);
        if (pages > 1) {
          const rest = await Promise.all(Array.from({ length: pages - 1 }, (_, i) => fetchPage(i + 2)));
          rest.forEach((r) => { all = all.concat(r.items || []); });
        }
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ at: Date.now(), items: all })); } catch (e) { /* kota */ }
        items = all.map(enrich);
        return items;
      })
      .catch((err) => {
        failed = true;
        console.warn('[mx-search]', err);
        items = [];
        return items;
      })
      .finally(() => { loading.hidden = true; });
    return loadPromise;
  }

  /* ---------- filtreleme ---------- */
  function scoreOf(it, tokens) {
    if (!tokens.length) return 1;
    let score = 0;
    for (const tk of tokens) {
      if (!it.hay.includes(tk)) return 0;
      if (it.nt.startsWith(tk)) score += 4;
      else if (it.nt.includes(' ' + tk)) score += 3;
      else if (it.nt.includes(tk)) score += 2;
      else score += 1;
    }
    return score;
  }

  function matches(it, skip) {
    if (skip !== 'type' && state.type.size && ![...state.type].some((c) => it.cols.includes(c))) return false;
    if (skip !== 'color' && state.color.size && ![...state.color].some((c) => it.colors.has(c))) return false;
    if (skip !== 'qty' && state.qty.size && !state.qty.has(it.qty)) return false;
    if (skip !== 'feat' && state.feat.size && ![...state.feat].every((f) => it.feats.has(f))) return false;
    return true;
  }

  function baseList() {
    const tokens = norm(state.q).split(/\s+/).filter(Boolean);
    const out = [];
    for (const it of items || []) {
      const s = scoreOf(it, tokens);
      if (s > 0) out.push([it, s]);
    }
    return out;
  }

  function filtered() {
    const list = baseList().filter(([it]) => matches(it));
    const by = state.sort;
    list.sort((a, b) => {
      if (by === 'price-asc') return a[0].p - b[0].p;
      if (by === 'price-desc') return b[0].p - a[0].p;
      if (by === 'az') return a[0].t.localeCompare(b[0].t, 'tr');
      return (b[1] - a[1]) || (Number(b[0].a) - Number(a[0].a));
    });
    return list.map(([it]) => it);
  }

  const FEAT_ORDER = ['stock', 'scented', 'gift', 'matte', 'premium', 'sale'];
  const featLabel = (k) => {
    const btn = $(`[data-mx-ss-quick="${k}"]`);
    if (btn) return btn.textContent.trim();
    return S['feat_' + k] || k;
  };

  function facetCounts(group) {
    const base = baseList().map(([it]) => it).filter((it) => matches(it, group));
    const counts = new Map();
    for (const it of base) {
      let keys = [];
      if (group === 'type') keys = it.cols;
      else if (group === 'color') keys = [...it.colors];
      else if (group === 'qty') keys = it.qty ? [it.qty] : [];
      else if (group === 'feat') keys = [...it.feats];
      keys.forEach((k) => counts.set(k, (counts.get(k) || 0) + 1));
    }
    return counts;
  }

  function allKeys(group) {
    const set = new Set();
    for (const it of items || []) {
      if (group === 'type') it.cols.forEach((c) => set.add(c));
      if (group === 'color') it.colors.forEach((c) => set.add(c));
      if (group === 'qty' && it.qty) set.add(it.qty);
      if (group === 'feat') it.feats.forEach((f) => set.add(f));
    }
    let arr = [...set];
    if (group === 'qty') arr.sort((a, b) => a - b);
    else if (group === 'feat') arr.sort((a, b) => FEAT_ORDER.indexOf(a) - FEAT_ORDER.indexOf(b));
    else if (group === 'color') arr.sort((a, b) => FAMILIES.findIndex((f) => f[1] === a) - FAMILIES.findIndex((f) => f[1] === b));
    else arr.sort((a, b) => a.localeCompare(b, 'tr'));
    return arr;
  }

  const keyLabel = (group, k) => {
    if (group === 'qty') return tpl(S.pieces, { count: k });
    if (group === 'feat') return featLabel(k);
    return k;
  };

  /* ---------- çizim ---------- */
  function renderFacets() {
    ['type', 'color', 'qty', 'feat'].forEach((group) => {
      const host = $(`[data-mx-ss-facet="${group}"]`);
      if (!host) return;
      const counts = facetCounts(group);
      const keys = allKeys(group).filter((k) => group !== 'feat' || !['stock', 'scented', 'gift'].includes(k));
      host.closest('.mx-ss__group').hidden = keys.length === 0;
      host.innerHTML = keys.map((k) => {
        const n = counts.get(k) || 0;
        const on = state[group].has(k);
        const dot = group === 'color' ? `<span class="mx-ss__dot" style="--dot:${SWATCH[k] || '#ccc'}"></span>` : '';
        return `<button type="button" class="mx-ss__chip" data-group="${group}" data-key="${esc(k)}" aria-pressed="${on}" ${!n && !on ? 'disabled' : ''}>${dot}<span>${esc(keyLabel(group, k))}</span><small>${n}</small></button>`;
      }).join('');
    });
  }

  function priceHtml(it) {
    const sale = it.c && it.c > it.p;
    return `<span class="mx-ss__price${sale ? ' mx-ss__price--sale' : ''}">${esc(it.pf)}${sale ? ` <s>${esc(it.cf)}</s>` : ''}</span>`;
  }

  function cardHtml(it) {
    const img = it.i
      ? `<img src="${esc(it.i)}" alt="" loading="lazy" decoding="async" width="${it.w}" height="${it.h}">`
      : '';
    const tag = !it.a ? `<span class="mx-ss__tag">${esc(S.sold_out)}</span>` : '';
    return `<li><a class="mx-ss__card" href="${esc(it.u)}" data-mx-ss-card><span class="mx-ss__media">${img}${tag}</span><span class="mx-ss__name">${esc(it.t)}</span>${priceHtml(it)}</a></li>`;
  }

  function activeCount() {
    return state.type.size + state.color.size + state.qty.size + state.feat.size;
  }

  function renderActive() {
    const chips = [];
    ['type', 'color', 'qty', 'feat'].forEach((g) => state[g].forEach((k) => {
      chips.push(`<button type="button" class="mx-ss__chip" data-remove-group="${g}" data-key="${esc(k)}" aria-label="${esc(S.remove)}: ${esc(keyLabel(g, k))}">${esc(keyLabel(g, k))} <svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M7 7l10 10M17 7 7 17"/></svg></button>`);
    }));
    activeWrap.innerHTML = chips.join('');
    activeWrap.hidden = chips.length === 0;
    const n = activeCount();
    filterCount.textContent = n;
    filterCount.hidden = n === 0;
    $$('[data-mx-ss-quick]').forEach((b) => b.setAttribute('aria-pressed', String(state.feat.has(b.dataset.mxSsQuick))));
  }

  function renderIntro() {
    const recent = getRecent();
    recentWrap.hidden = recent.length === 0;
    recentEl.innerHTML = recent.map((r) => `<button type="button" class="mx-ss__chip" data-recent="${esc(r)}">${esc(r)}</button>`).join('');
    const types = allKeys('type').map((k) => [k, (items || []).filter((it) => it.cols.includes(k)).length]).sort((a, b) => b[1] - a[1]).slice(0, 10);
    catsEl.innerHTML = types.map(([k, n]) => `<li><button type="button" data-cat="${esc(k)}"><span>${esc(k)}</span><span>${n}</span></button></li>`).join('');
    const featured = (items || []).filter((it) => it.a && it.i).slice(0, 4);
    featuredEl.innerHTML = featured.map(cardHtml).join('');
  }

  function render() {
    const hasQuery = state.q.trim().length > 0;
    const isFiltering = hasQuery || activeCount() > 0;
    clearBtn.hidden = !hasQuery;
    renderActive();
    renderFacets();
    const url = new URL(dialog.dataset.searchUrl || '/search', location.origin);
    url.searchParams.set('q', state.q.trim() || '*');
    url.searchParams.set('type', 'product');
    allLink.href = url.pathname + url.search;

    if (!items) return;
    if (failed) {
      intro.hidden = true;
      results.hidden = false;
      grid.innerHTML = '';
      countEl.textContent = '';
      emptyText.textContent = S.error || '';
      empty.querySelector('[data-mx-ss-reset]').hidden = true;
      empty.hidden = false;
      moreBtn.hidden = true;
      return;
    }
    intro.hidden = isFiltering;
    results.hidden = !isFiltering;
    const list = filtered();
    applyBtn.textContent = tpl(S.show, { count: list.length });
    if (!isFiltering) { renderIntro(); return; }
    countEl.textContent = countLabel(list.length);
    grid.innerHTML = list.slice(0, shown).map(cardHtml).join('');
    empty.hidden = list.length > 0;
    emptyText.textContent = S.no_results || '';
    empty.querySelector('[data-mx-ss-reset]').hidden = false;
    moreBtn.hidden = list.length <= shown;
  }

  /* ---------- son aramalar ---------- */
  function getRecent() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]').slice(0, 6); } catch (e) { return []; }
  }
  function saveRecent(q) {
    q = String(q || '').trim();
    if (q.length < 2) return;
    const list = [q, ...getRecent().filter((r) => norm(r) !== norm(q))].slice(0, 6);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (e) { /* yok */ }
  }

  /* ---------- aç / kapat ---------- */
  function open(trigger) {
    lastFocus = trigger || document.activeElement;
    if (failed) { failed = false; items = null; loadPromise = null; }
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    document.documentElement.style.overflow = 'hidden';
    render();
    loadIndex().then(() => render());
    requestAnimationFrame(() => input.focus({ preventScroll: true }));
  }
  function close() {
    if (dialog.open) {
      if (typeof dialog.close === 'function') dialog.close();
      else dialog.removeAttribute('open');
    }
  }
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = '';
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
  });

  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-mx-ss-open]');
    if (t) { e.preventDefault(); open(t); }
  });
  $$('[data-mx-ss-close]').forEach((b) => b.addEventListener('click', close));
  dialog.addEventListener('click', (e) => { if (e.target === dialog) close(); });

  /* ---------- etkileşim ---------- */
  let timer;
  input.addEventListener('input', () => {
    clearTimeout(timer);
    timer = setTimeout(() => { state.q = input.value; shown = PAGE; render(); }, 120);
  });
  form.addEventListener('submit', (e) => {
    if (failed) return; /* veri yüklenemezse normal arama sayfasına gider */
    e.preventDefault();
    state.q = input.value; shown = PAGE;
    saveRecent(state.q);
    input.blur();
    render();
  });
  clearBtn.addEventListener('click', () => { input.value = ''; state.q = ''; shown = PAGE; render(); input.focus(); });

  filtersToggle.addEventListener('click', () => {
    const openNow = filtersPanel.hidden;
    filtersPanel.hidden = !openNow;
    filtersToggle.setAttribute('aria-expanded', String(openNow));
    if (openNow) { body.scrollTo({ top: 0, behavior: 'smooth' }); input.blur(); }
  });
  applyBtn.addEventListener('click', () => {
    filtersPanel.hidden = true;
    filtersToggle.setAttribute('aria-expanded', 'false');
    body.scrollTo({ top: 0, behavior: 'smooth' });
  });
  $$('[data-mx-ss-reset]').forEach((b) => b.addEventListener('click', () => {
    ['type', 'color', 'qty', 'feat'].forEach((g) => state[g].clear());
    shown = PAGE; render();
  }));
  $$('[data-mx-ss-quick]').forEach((b) => b.addEventListener('click', () => {
    const k = b.dataset.mxSsQuick;
    if (state.feat.has(k)) state.feat.delete(k); else state.feat.add(k);
    shown = PAGE; render();
  }));
  sortSel.addEventListener('change', () => { state.sort = sortSel.value; shown = PAGE; render(); });
  moreBtn.addEventListener('click', () => { shown += PAGE; render(); });

  dialog.addEventListener('click', (e) => {
    const chip = e.target.closest('[data-group]');
    if (chip && !chip.disabled) {
      const g = chip.dataset.group;
      const k = g === 'qty' ? parseInt(chip.dataset.key, 10) : chip.dataset.key;
      if (state[g].has(k)) state[g].delete(k); else state[g].add(k);
      shown = PAGE; render();
      return;
    }
    const rm = e.target.closest('[data-remove-group]');
    if (rm) {
      const g = rm.dataset.removeGroup;
      const k = g === 'qty' ? parseInt(rm.dataset.key, 10) : rm.dataset.key;
      state[g].delete(k); shown = PAGE; render();
      return;
    }
    const rec = e.target.closest('[data-recent]');
    if (rec) { input.value = rec.dataset.recent; state.q = input.value; shown = PAGE; render(); return; }
    const cat = e.target.closest('[data-cat]');
    if (cat) { state.type.clear(); state.type.add(cat.dataset.cat); shown = PAGE; render(); body.scrollTo({ top: 0 }); return; }
    if (e.target.closest('[data-mx-ss-recent-clear]')) {
      try { localStorage.removeItem(RECENT_KEY); } catch (err) { /* yok */ }
      render();
      return;
    }
    if (e.target.closest('[data-mx-ss-card]') && state.q.trim()) saveRecent(state.q);
  });
})();
